import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitolavasacab() {



  const cardData =
  {
    keyword: 'Mumbai to Lavasa Cab ',
    heading: 'Shambhu Cabs: Mumbai to Lavasa Cab  ',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Lavasa Cab services, providing safe, comfortable, and hassle-free travel for families, friends, corporate travelers, and weekend getaway seekers heading to the picturesque hill city of Lavasa. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to Lavasa with well-maintained vehicles and spacious seating. With flexible one-way and round-trip options, experienced chauffeurs, and 24/7 booking support, Shambhu Cabs makes your trip stress-free and convenient. From South Mumbai to Thane, Andheri to Vashi, Shambhu Cabs provides doorstep pickup and trusted Mumbai to Lavasa cab services for travelers seeking comfort, safety, and a memorable travel experience',

    top: 'Top Places to Visit in Lavasa with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Lavasa Waterfront",
    "description": "The Lavasa Waterfront is the central hub of this planned hill city, featuring a picturesque promenade along the serene Dasve Lake. Visitors can enjoy boating, leisurely walks, and vibrant cafes with scenic views of the Western Ghats. The waterfront area also hosts events, music festivals, and cultural programs, making it the heart of Lavasa’s recreational and social life."
  },
  {
    "title": "Temghar Dam",
    "description": "Temghar Dam, located near Lavasa, is a massive reservoir built on the Mutha River. The dam is surrounded by lush greenery and hills, providing a perfect spot for photography, picnics, and enjoying the tranquil sound of flowing water. The scenic landscape during sunrise and sunset is particularly mesmerizing."
  },
  {
    "title": "Varasgaon Lake",
    "description": "Varasgaon Lake is another prominent waterbody near Lavasa, known for its calm and pristine environment. Visitors often indulge in boating, nature walks, and photography. The lake is surrounded by hills and forests, making it an ideal escape for those seeking solitude and natural beauty."
  },
  {
    "title": "Lavasa City Hill Treks",
    "description": "Lavasa offers multiple trekking trails across its surrounding hills and valleys. Popular treks include climbs to vantage points offering panoramic views of the entire city, lakes, and the Sahyadri ranges. Trekkers can explore diverse flora, birdlife, and enjoy the fresh mountain air while experiencing the natural beauty of Lavasa."
  },
  {
    "title": "Dinosaur Park",
    "description": "Lavasa’s Dinosaur Park is a fun and educational destination for families and children. Featuring life-sized dinosaur models, interactive exhibits, and walking trails, the park provides an engaging way to learn about prehistoric creatures while enjoying the scenic outdoors."
  },
  {
    "title": "Nature Walks & Gardens",
    "description": "Lavasa is dotted with beautifully landscaped gardens, walking paths, and green spaces. Visitors can enjoy peaceful nature walks, birdwatching, and guided tours exploring the local flora and fauna. The gardens also serve as relaxing spots for photography and unwinding amidst nature."
  },
  {
    "title": "Mist Garden",
    "description": "Mist Garden in Lavasa is a serene and scenic garden designed for relaxation and meditation. With gentle water features, shaded walking paths, and panoramic views of the surrounding hills, it offers a perfect spot for morning walks, yoga sessions, or simply soaking in the natural beauty."
  },
  {
    "title": "Rock Climbing and Adventure Activities",
    "description": "Lavasa offers a variety of adventure sports including rock climbing, rappelling, zip-lining, and trekking. These activities are designed for beginners as well as experienced enthusiasts, making the city a hub for adventure tourism amidst the scenic Western Ghats."
  },
  {
    "title": "Dasve Lake Viewpoint",
    "description": "The Dasve Lake Viewpoint offers breathtaking panoramic views of the lake and the surrounding Lavasa hills. Visitors can enjoy sunrise and sunset photography, birdwatching, or simply spend quiet moments taking in the peaceful ambiance of this elevated vantage point."
  },
  {
    "title": "Cafes and Riverside Promenade",
    "description": "Lavasa’s riverside promenade is lined with numerous cafes, restaurants, and shops. Visitors can enjoy local and international cuisine, engage in casual shopping, or simply relax while admiring the lakeside views. The promenade comes alive during evenings with music, cultural performances, and vibrant city lights reflecting on the water."
  }
],

"services": [
  {
    "name": "Mumbai Lavasa Taxi",
    "description": "Mumbai Lavasa Taxi provides reliable and comfortable intercity travel from Mumbai to Lavasa. With professional drivers, well-maintained vehicles, and flexible booking options, passengers can enjoy a smooth journey. Ideal for family trips, corporate travel, and leisure getaways, this service ensures punctual pickups, safe driving, and a stress-free road trip experience along scenic routes."
  },
  {
    "name": "Lavasa Trip Cab Mumbai",
    "description": "Lavasa Trip Cab Mumbai offers hassle-free transportation for travelers planning trips to Lavasa. Equipped with spacious sedans and SUVs, the service ensures professional drivers, scenic routes, and timely arrivals, making it perfect for sightseeing, weekend getaways, and corporate trips from Mumbai."
  },
  {
    "name": "One-Way Cab Mumbai Lavasa",
    "description": "One-Way Cab Mumbai Lavasa is designed for passengers needing single-drop service without a return journey. Ideal for short trips, business travel, or personal visits, this service provides economical pricing, comfortable vehicles, and professional drivers for a smooth and convenient ride to Lavasa."
  },
  {
    "name": "Affordable Lavasa Cab Mumbai",
    "description": "Affordable Lavasa Cab Mumbai offers budget-friendly options for intercity travel while maintaining high standards of comfort and safety. Perfect for students, solo travelers, and small families, this service ensures reliable transportation from Mumbai to Lavasa without compromising quality."
  },
  {
    "name": "Best Taxi Mumbai Lavasa",
    "description": "Best Taxi Mumbai Lavasa is known for its top-quality vehicles, punctual service, and professional drivers. Passengers can enjoy a hassle-free journey, comfortable seating, and safe driving, making it the preferred choice for leisure trips, family outings, and business travel to Lavasa."
  },
  {
    "name": "SUV Cab Mumbai Lavasa",
    "description": "SUV Cab Mumbai Lavasa caters to groups or families traveling together, offering spacious and comfortable vehicles for long-distance trips. Equipped with modern amenities and safety features, these SUVs ensure a smooth journey with ample luggage space, ideal for extended road trips."
  },
  {
    "name": "Sedan Cab Mumbai Lavasa",
    "description": "Sedan Cab Mumbai Lavasa provides elegant and efficient sedans for travelers seeking a balance of comfort and economy. With experienced drivers and well-maintained vehicles, passengers enjoy a relaxed and smooth ride from Mumbai to Lavasa, suitable for couples, small families, and business travelers."
  },
  {
    "name": "Mumbai Lavasa Outstation Cab",
    "description": "Mumbai Lavasa Outstation Cab specializes in long-distance travel from Mumbai to Lavasa. With a focus on safety, comfort, and customer satisfaction, the service provides well-maintained vehicles and experienced drivers, ensuring a smooth and enjoyable journey for all passengers."
  },
  {
    "name": "24×7 Lavasa Cab Mumbai",
    "description": "24×7 Lavasa Cab Mumbai provides round-the-clock availability for travelers needing intercity transport to Lavasa. With flexible timing, on-demand booking, and professional drivers, this service ensures convenience and safety at any hour of the day."
  },
  {
    "name": "Fast Cab Mumbai Lavasa",
    "description": "Fast Cab Mumbai Lavasa offers time-efficient travel with professional drivers, well-maintained vehicles, and direct routes to Lavasa. Ideal for urgent business trips, last-minute travel plans, or travelers on tight schedules, this service prioritizes speed without compromising safety or comfort."
  },
  {
    "name": "Corporate Cab Mumbai Lavasa",
    "description": "Corporate Cab Mumbai Lavasa caters to business travelers and corporate clients, providing premium vehicles and professional chauffeur-driven service. Punctuality, comfort, and reliability are emphasized for meetings, conferences, or corporate visits between Mumbai and Lavasa."
  },
  {
    "name": "Premium Cab Mumbai Lavasa",
    "description": "Premium Cab Mumbai Lavasa offers luxury vehicles and high-end service for travelers seeking maximum comfort and style. Equipped with experienced chauffeurs, this service ensures a smooth and elegant journey, ideal for VIPs, executives, and special occasions."
  },
  {
    "name": "Family Cab Mumbai Lavasa",
    "description": "Family Cab Mumbai Lavasa is designed for group and family travel, providing spacious and comfortable vehicles for long-distance trips. With attentive drivers and safety measures in place, the service ensures a relaxed and enjoyable journey suitable for all ages."
  },
  {
    "name": "Safe Taxi Mumbai Lavasa",
    "description": "Safe Taxi Mumbai Lavasa prioritizes passenger safety with trained drivers, well-maintained vehicles, and adherence to all road safety protocols. Suitable for solo travelers, families, and corporate clients, this service ensures a secure and dependable journey from Mumbai to Lavasa."
  },
  {
    "name": "Express Highway Cab Lavasa",
    "description": "Express Highway Cab Lavasa offers a fast and efficient route to Lavasa via highways, reducing travel time while maintaining passenger comfort and safety. Ideal for travelers looking for a quick and smooth road trip experience from Mumbai."
  },
  {
    "name": "Long Trip Cab Mumbai Lavasa",
    "description": "Long Trip Cab Mumbai Lavasa is perfect for extended journeys and multi-day trips to Lavasa. With well-maintained vehicles, experienced drivers, and flexible travel schedules, this service ensures a comfortable and hassle-free long-distance experience."
  },
  {
    "name": "Mumbai to Lavasa Pickup Drop",
    "description": "Mumbai to Lavasa Pickup Drop provides door-to-door service, offering maximum convenience for passengers. With professional drivers, comfortable vehicles, and flexible timings, this service ensures a seamless and stress-free journey from Mumbai to Lavasa."
  }
],

"tableData": [
  ["Mumbai Lavasa Taxi", "Lavasa Trip Cab Mumbai"],
  ["One-Way Cab Mumbai Lavasa", "Affordable Lavasa Cab Mumbai"],
  ["Best Taxi Mumbai Lavasa", "SUV Cab Mumbai Lavasa"],
  ["Sedan Cab Mumbai Lavasa", "Mumbai Lavasa Outstation Cab"],
  ["24×7 Lavasa Cab Mumbai", "Fast Cab Mumbai Lavasa"],
  ["Corporate Cab Mumbai Lavasa", "Premium Cab Mumbai Lavasa"],
  ["Family Cab Mumbai Lavasa", "Safe Taxi Mumbai Lavasa"],
  ["Express Highway Cab Lavasa", "Long Trip Cab Mumbai Lavasa"],
  ["Mumbai to Lavasa Pickup Drop", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Lavasa Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai to Lavasa cab services, perfect for weekend getaways, hill station trips, and leisurely escapes from the city."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs for a smooth and relaxing journey to Lavasa."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Ghat and Hill Routes",
    "WhyChoosedescription": "Our professional drivers are familiar with the Mumbai to Lavasa ghat and hill routes, ensuring safe, timely, and comfortable travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy upfront and clear pricing—fuel, tolls, and driver allowances included—making your Mumbai to Lavasa cab trip hassle-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, travel queries, and route guidance."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Hill Station Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental plans tailored to your Mumbai to Lavasa travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth service, making your Mumbai to Lavasa journey stress-free and comfortable."
  }
]























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Lavasa cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Lavasa cab services with professional and experienced drivers.',
  },
  {
    question: 'How can I book a Mumbai to Lavasa cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for quick assistance.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Lavasa cab bookings?',
    answer: 'Shambhu Cabs offers well-maintained sedans, SUVs, and luxury cars suitable for a safe and comfortable trip from Mumbai to Lavasa.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Lavasa route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Mumbai to Lavasa route to ensure a smooth and safe journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Lavasa cab?',
    answer: 'Absolutely. You can select your preferred pickup point in Mumbai and drop-off location anywhere in Lavasa.',
  },
  {
    question: 'Is the Mumbai to Lavasa cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock Mumbai to Lavasa cab booking services to match your travel schedule.',
  },
  {
    question: 'Are safety and hygiene measures followed for Mumbai to Lavasa cab bookings?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene protocols for passenger well-being.',
  },
  {
    question: 'What payment options are available for Mumbai to Lavasa cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during the Mumbai to Lavasa journey?',
    answer: 'Yes, our 24x7 customer support team is available to assist you throughout your Mumbai to Lavasa travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohan Deshmukh',
    feedback: 'Our Mumbai to Lavasa trip with Shambhu Cabs was comfortable and hassle-free. The driver was punctual and professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Patil',
    feedback: 'Highly reliable Mumbai to Lavasa cab service. Smooth journey, clean car, and excellent support from Shambhu Cabs.',
    rating: 5,
  },
];















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Lavasa Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-lavasa-cab.jpg",
  "description": "Shambhu Cabs provides safe and reliable Mumbai to Lavasa cab services for one-way and round trips. Perfect for family trips, corporate travel, hill station visits, and long journeys. Book sedans, SUVs, or premium cars for fast, comfortable, and affordable travel with professional drivers and 24×7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-lavasa-cab"
  }
};



  return (
    <div>

<Helmet>
  <title>Mumbai to Lavasa Cab | Hill Station & Outstation Taxi | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Lavasa cab with Shambhu Cabs. Safe, affordable, and comfortable taxi service for hill station trips, family outings, corporate travel, and long trips. Available 24×7 with sedan, SUV, and premium cars."
  />

  <meta
    name="keywords"
    content="Mumbai Lavasa Taxi, Lavasa Trip Cab Mumbai, One-Way Cab Mumbai Lavasa, Affordable Lavasa Cab Mumbai, Best Taxi Mumbai Lavasa, SUV Cab Mumbai Lavasa, Sedan Cab Mumbai Lavasa, Mumbai Lavasa Outstation Cab, 24×7 Lavasa Cab Mumbai, Fast Cab Mumbai Lavasa, Corporate Cab Mumbai Lavasa, Premium Cab Mumbai Lavasa, Family Cab Mumbai Lavasa, Safe Taxi Mumbai Lavasa, Express Highway Cab Lavasa, Long Trip Cab Mumbai Lavasa, Mumbai to Lavasa Pickup Drop"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/16.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitolavasacab;